/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */
import * as THREE from "three";
import { SkeletonUtils } from "three/examples/jsm/utils/SkeletonUtils";
import * as TWEEN from "@tweenjs/tween.js";
import { Vector3 } from "three";
import { buildGraph } from "./MachineHelper";
import Event from "./Event";
import { ANIMATION_EVENTS } from "../constants";

const mod = () => {
  const models = {};
  const modelTriggers = {};
  const fadeOutTime = 0.2;
  const playClipAnimationFromQueue = (animationQueue, modelId) => {
    const prevAction = modelTriggers[modelId]?.prevAction;
    if (animationQueue.length > 0 && animationQueue[0].type === "clip") {
      if (prevAction) {
        prevAction.fadeOut(fadeOutTime);
        setTimeout(() => {
          prevAction.stop();
        }, fadeOutTime * 1000);
      }
      animationQueue[0].value.play();
    }
  };

  const playNext = (animationQueue, modelId, type = "playAnimation") => {
    animationQueue.shift();
    if (animationQueue.length > 0) {
      console.log(
        "playing tween animation now playing",
        Date.now()
        // animationQueue[0].value.getClip().name
      );
      if (animationQueue[0].type === "clip")
        playClipAnimationFromQueue(animationQueue, modelId);
      if (animationQueue[0].type === "tween") animationQueue[0].value.start();
      if (animationQueue[0].type === "texture") animationQueue[0].value();
    } else if (type === "playAnimation") {
      console.log("End animation sequence here");
      Event.sendSMEvent(ANIMATION_EVENTS.ANIMATION_QUEUE_COMPLETE);
    } else {
      console.log("Do Nothing");
    }
  };

  const instantiateIfNull = (modelId) => {
    const modelObject = models[modelId];
    if (!(modelId in modelTriggers)) {
      modelTriggers[modelId] = {};
      modelTriggers[modelId].animationQueue = [];
      const { animationQueue } = modelTriggers[modelId];
      const mixerInstance = new THREE.AnimationMixer(modelObject.scene);
      console.log("Instantiate");
      mixerInstance.addEventListener("finished", (data) => {
        console.log(
          "playing armodel clip animation clipAnimation trigger, finished from event",
          Date.now(),
          data.action.getClip().name
        );
        modelTriggers[modelId].prevAction = data.action;
        playNext(animationQueue, modelId);
      });
      modelTriggers[modelId].animationMixer = mixerInstance;
      const clock = new THREE.Clock();
      (function anim() {
        // snip
        const delta = clock.getDelta();
        requestAnimationFrame(anim);
        mixerInstance.update(delta);
      })();
    }
  };

  const createTween = (vector, target, duration, animationQueue, modelId) => {
    return new TWEEN.Tween(vector)
      .to({ x: target.x, y: target.y, z: target.z }, duration)
      .onUpdate(() => {
        // console.log("updating tween", data);
      })
      .onComplete((data) => {
        console.log("completed tween animation", data);
        playNext(animationQueue, modelId);
      });
  };

  const checkMaterialNames = (materialName, materialNodesMain) => {
    let finalMaterialName = "";
    const { materials } = materialNodesMain;
    const allKeys = Object.keys(materials);

    const match = (a, b) => {
      if (a === b) {
        return true;
      }
      if (a.includes(b)) {
        return true;
      }
      return false;
    };
    let maxLength = 0;
    let mainIndex = 0;
    const newarray = {};
    materialName.split("").forEach((ch) => {
      if (ch in newarray) {
        newarray[ch] += 1;
      } else {
        newarray[ch] = 1;
      }
    });
    for (let index = 0; index < allKeys.length; index += 1) {
      const array = { ...newarray };
      const keyName = allKeys[index];
      let count = 0;
      if (match(keyName.toLowerCase(), materialName.toLowerCase())) {
        finalMaterialName = keyName;
        break;
      } else {
        keyName.split("").forEach((char) => {
          if (char in array && array[char] > 0) {
            array[char] -= 1;
          }
        });
        Object.keys(array).forEach((key) => {
          count += array[key] > 0 ? array[key] : 0;
        });
        if ((materialName.length - count) / materialName.length > maxLength) {
          mainIndex = index;
          maxLength = (materialName.length - count) / materialName.length;
        }
      }
    }
    if (finalMaterialName === "") {
      finalMaterialName = allKeys[mainIndex];
    }
    console.log("matchp", finalMaterialName);
    return finalMaterialName;
  };

  const applyMaterialPhysical = async (
    modelId,
    materialName,
    materialConfig,
    getAssetCallback
  ) => {
    instantiateIfNull(modelId);
    const { animationQueue } = modelTriggers[modelId];
    const applicableMaterial = {};
    const model = models[modelId];

    Object.keys(materialConfig).forEach((key) => {
      console.log("🚀 ~ file: ARModels.js ~ line 153 ~ Object.keys ~ key", key);
      if (key.includes("map") || key.includes("Map"))
        applicableMaterial[key] = getAssetCallback(materialConfig[key]);
      else applicableMaterial[key] = materialConfig[key];
    });
    console.log(
      "apply material",
      modelId,
      model,
      materialName,
      materialConfig,
      applicableMaterial
    );
    // if (model.materials[materialName].map)
    //   model.materials[materialName].map.dispose();
    // if (model.materials[materialName].aoMap)
    //   model.materials[materialName].aoMap.dispose();
    // if (model.materials[materialName].roughnessMap)
    //   model.materials[materialName].roughnessMap.dispose();
    // if (model.materials[materialName].metallicMap)
    //   model.materials[materialName].metallicMap.dispose();
    // if (model.materials[materialName].normalMap)
    //   model.materials[materialName].normalMap.dispose();

    Object.keys(materialConfig).forEach((mapName) => {
      console.log(
        "appy material",
        model,
        materialName,
        checkMaterialNames(materialName, model)
      );
      if (
        model.materials[checkMaterialNames(materialName, model)][mapName] !=
        null
      ) {
        if (
          model.materials[checkMaterialNames(materialName, model)][
            mapName
          ] instanceof THREE.Texture
        )
          model.materials[checkMaterialNames(materialName, model)][
            mapName
          ].dispose();
        model.materials[checkMaterialNames(materialName, model)][mapName] =
          applicableMaterial[mapName];
      }
    });
    // model.materials[materialName].needsUpdate = true;
    playNext(animationQueue, modelId, "applyTexture");
  };
  const getModel = (modelId) => {
    return models[modelId];
  };

  const updateEnvMap = (modelId, envMap) => {
    console.log("update env map", modelId, envMap);
    const model = models[modelId];
    Object.values(model.materials).forEach((material) => {
      material.envMap = envMap;
      material.needsUpdate = true;
    });
  };

  const updateEnvMapIntensity = (modelId, intensity) => {
    const model = models[modelId];
    console.log("update env map", modelId, intensity, models);
    Object.values(model.materials).forEach((material) => {
      material.envMapIntensity = intensity;
      material.needsUpdate = true;
    });
  };

  return {
    updateEnvMap,
    updateEnvMapIntensity,
    getModels: () => {
      return models;
    },
    updateModelOnLoad: (modelId) => {
      const model = getModel(modelId);

      const { materials } = model;
      // console.log("update on load", model, materials);
      Object.keys(materials).forEach((materialName) => {
        Object.values(materials[materialName]).forEach((attributeValue) => {
          if (attributeValue instanceof THREE.Texture) {
            console.log(
              "update on load pre",
              materialName,
              attributeValue.encoding
            );
            attributeValue.encoding = THREE.sRGBEncoding;
            attributeValue.wrapS = THREE.RepeatWrapping;
            attributeValue.wrapT = THREE.RepeatWrapping;
            console.log(
              "update on load post",
              materialName,
              attributeValue.encoding
            );
          }
        });
        materials[materialName].needsUpdate = true;
      });
      console.log(
        "updateModelOnLoad",
        model.materials,
        modelId,
        models[modelId],
        materials
      );
    },
    getModel,
    cloneandAddModel: (gltfObject, modelId) => {
      const clonedGltfObject = { ...gltfObject };
      const clonedObject = SkeletonUtils.clone(gltfObject.scene);
      clonedGltfObject.scene = clonedObject;
      const nodeMaterialObject = buildGraph(clonedObject);
      clonedGltfObject.nodes = nodeMaterialObject.nodes;
      clonedGltfObject.materials = nodeMaterialObject.materials;

      models[modelId] = clonedGltfObject;
      console.log(
        "cloning",
        gltfObject.scene.uuid,
        clonedGltfObject.scene.uuid,
        modelId,
        models[modelId],
        Object.keys(models[modelId])
      );
      return clonedGltfObject;
    },
    getPositonOfModel: (modelId) => {
      console.log(modelId);
      console.log(models);
      return models[modelId].scene.position;
    },
    getRotationOfModel: (modelId) => {
      return models[modelId].scene.rotation;
    },
    setRotationOfModel: (modelId, rotationToSet) => {
      const modelObject = models[modelId];
      modelObject.scene.rotation.y = rotationToSet.y;
    },
    setPositonOfModel: (modelId, positionToSet) => {
      const modelObject = models[modelId];
      modelObject.scene.position.x = positionToSet.x;
      modelObject.scene.position.y = positionToSet.y;
      modelObject.scene.position.z = positionToSet.z;
    },
    applyMaterial: (
      modelId,
      materialName,
      materialConfig,
      getAssetCallback
    ) => {
      console.log(
        "calling armodelsxyz appplymaterial",
        materialName,
        materialConfig
      );
      instantiateIfNull(modelId);
      const queue = modelTriggers[modelId].animationQueue;
      const action = () =>
        applyMaterialPhysical(
          modelId,
          materialName,
          materialConfig,
          getAssetCallback
        );
      queue.push({ type: "texture", value: action });
      if (queue.length === 1) {
        action();
      }
    },

    playClipAnimation: (modelId, clipAnimationConfig, clampFinishFlag) => {
      instantiateIfNull(modelId);
      console.log(
        "calling armodelsxyz clicpanimation mainanimation",
        clipAnimationConfig
      );
      const modelObject = models[modelId];
      const mixer = modelTriggers[modelId].animationMixer;
      const queue = modelTriggers[modelId].animationQueue;
      console.log(
        "playClipAnimation",
        modelId,
        clipAnimationConfig,
        modelObject
      );

      Object.values(modelObject.animations).forEach((animationClip) => {
        if (
          animationClip?.name?.toLowerCase() ===
          clipAnimationConfig?.clipName?.toLowerCase()
        ) {
          console.log("animationloop");
          const clip = animationClip;
          const action = mixer.clipAction(clip).setLoop(THREE.LoopOnce);
          let duration = Math.abs(
            (clipAnimationConfig.endFrame - clipAnimationConfig.startFrame) / 24
          );
          if (
            clipAnimationConfig.endFrame === 0 ||
            clipAnimationConfig.endFrame == null
          ) {
            duration = animationClip.duration;
          }
          action.setDuration(duration);
          action.clampWhenFinished = clampFinishFlag;
          queue.push({ type: "clip", value: action });
          console.log(
            "playing armodel clip animation",
            clipAnimationConfig,
            queue.length,
            duration,
            queue
          );
          if (queue.length === 1) playClipAnimationFromQueue(queue, modelId);
        }
      });
    },

    playDynamicAnimation: (modelId, dynamicAnimationConfig) => {
      console.log(
        "calling armodelsxyz appplymaterial dynamic",
        dynamicAnimationConfig
      );
      instantiateIfNull(modelId);
      const modelObject = models[modelId];
      const queue = modelTriggers[modelId].animationQueue;
      if (dynamicAnimationConfig.name === "rotate") {
        const action = createTween(
          modelObject.scene.rotation,
          new Vector3(0, dynamicAnimationConfig.angle, 0),
          dynamicAnimationConfig.duration,
          queue,
          modelId
        ).delay(dynamicAnimationConfig.delay);
        console.log("adding tween", action, queue.length);
        queue.push({ type: "tween", value: action });
        if (queue.length === 1) {
          action.start();
        }
      }
    },

    removeModelObject: () => {},
  };
};
const ARModels = mod();

export default ARModels;
